import { HeaderSearch } from './lib/header-search.js';
customElements.define('cipublic-header-search', HeaderSearch);
//# sourceMappingURL=cipublic-header-search.js.map